import { render, staticRenderFns } from "./bookDialog.vue?vue&type=template&id=6116f7fd&"
import script from "./bookDialog.vue?vue&type=script&lang=js&"
export * from "./bookDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports